import { render } from "./CreateOrganization.vue?vue&type=template&id=ab5bcd26"
import script from "./CreateOrganization.vue?vue&type=script&lang=js"
export * from "./CreateOrganization.vue?vue&type=script&lang=js"
script.render = render

export default script